<div class="page-header">
  <app-page-title>
    <button page-title-action class="btn btn-primary btn-sm d-inline-flex align-items-center gap-2"
            (click)="save()" [disabled]="isSubmitting()">
      @if (isSubmitting()) {
        <span class="spinner-border spinner-border-sm"></span>
      }
      <span>บันทึก</span>
    </button>
  </app-page-title>
</div>

@if (isLoading()) {
  <div class="text-center py-5 text-body-secondary">กำลังโหลดข้อมูล...</div>
} @else {
  <form [formGroup]="form" (ngSubmit)="save()">
    <div class="card shadow-sm border-0 mb-4">
      <div class="card-header py-3 bg-white">
        <div class="fw-semibold">การลบ Log อัตโนมัติ</div>
      </div>
      <div class="card-body">
        <div class="row mb-3 align-items-center">
          <div class="col-12 col-md-3">
            <label for="retentionDays" class="form-label required mb-0">จำนวนวันที่จะลบ Log อัตโนมัติ</label>
          </div>
          <div class="col-12 col-md-3">
            <div class="input-group input-group-sm">
              <input type="number" class="form-control" id="retentionDays"
                     formControlName="retentionDays"
                     [min]="minDays" [max]="maxDays" step="1"
                     [class.is-invalid]="submitted && form.get('retentionDays')?.invalid">
              <span class="input-group-text">วัน</span>
            </div>
            @if (submitted && form.get('retentionDays')?.hasError('required')) {
              <div class="invalid-feedback d-block">กรุณากรอกจำนวนวัน</div>
            } @else if (submitted && form.get('retentionDays')?.invalid) {
              <div class="invalid-feedback d-block">จำนวนวันต้องอยู่ระหว่าง {{ minDays }} ถึง {{ maxDays }}</div>
            }
          </div>
        </div>

        <p class="text-body-secondary small mb-1">
          ระบบจะลบรายการบันทึกกิจกรรม (Log) ที่เก่ากว่าจำนวนวันที่กำหนดโดยอัตโนมัติทุกคืน
          ยกเว้นรายการที่ถูก "เก็บรักษาข้อมูลไว้" จากหน้ารายการบันทึกกิจกรรม (Log)
        </p>
        @if (updatedAt()) {
          <p class="text-body-secondary small mb-0">แก้ไขล่าสุด {{ updatedAt() | thaidatetime }}</p>
        }
      </div>
    </div>
  </form>
}
